import {Observable, of, throwError} from 'rxjs';
import {Project} from '../../models/project';
import {ProjectReferenceService} from '../project-reference.service';
import {ProjectReference} from '../../models/project-reference';
import {mockProjects} from './project.service.mock';
import {PageResponse, wrapInPageResponse} from '../../models/page-response';
import {ProjectReferenceDetailResponse} from '../../models/project-reference-detail.response';
import {ProjectReferenceSearchResponse} from '../../models/project-reference-search-response';
import {mockProjectReferencePhoto} from './project-reference-photo.service.mock';
import {SearchFacetGroupCollection} from '../../models/search-facet';

export const mockProjectReferences: (ProjectReference)[] = [
    {
        id: 1,
        project: mockProjects[0],
        createdBy: 'r.knol@recognize.nl',
        createdAt: new Date(),
        updatedBy: 'r.knol@recognize.nl',
        updatedAt: new Date(),
        status: 'Published',
    },
    {
        id: 2,
        project: mockProjects[2],
        createdBy: 'r.knol@recognize.nl',
        createdAt: new Date(),
        updatedBy: 'r.knol@recognize.nl',
        updatedAt: new Date(),
        status: 'Concept',
    },
    {
        id: 3,
        project: mockProjects[1],
        createdBy: 'r.knol@recognize.nl',
        createdAt: new Date(),
        updatedBy: 'r.knol@recognize.nl',
        updatedAt: new Date(),
        status: 'Concept',
    }
];

export class ProjectReferenceServiceMock implements ProjectReferenceService {
    suggest(search: string): Observable<string[]> {
        return of([search]);
    }

    createReference(project: Project): Observable<ProjectReference> {
        const newRef: ProjectReference = {
            id: mockProjectReferences.length + 1,
            status: 'Concept',
            project,
            updatedAt: new Date(),
            createdAt: new Date(),
            createdBy: 'test user',
            updatedBy: 'test user',
        };
        project.reference = newRef;
        mockProjectReferences.push(newRef);

        return of(newRef);
    }

    updateReference(id: number, description: string): Observable<ProjectReferenceDetailResponse> {
        return of();
    }

    publishReference(id: number): Observable<void> {
        const reference = mockProjectReferences.find(item => item.id == id)
        if (reference) {
            reference.status = 'Published'
        }
        return of();
    }

    unpublishReference(id: number): Observable<void> {
        const reference = mockProjectReferences.find(item => item.id == id)
        if (reference) {
            reference.status = 'Concept'
        }
        return of();
    }

    listReferences(
        search: string,
        filter: { [key: string]: (string|number)[] },
        page: number
    ): Observable<PageResponse<ProjectReferenceSearchResponse>> {
        return of(wrapInPageResponse(
            mockProjectReferences
                .map(reference => ({
                    ...reference,
                    id: reference.id as number,
                    name: reference.project.name,
                    city: reference.project.city,
                    companyName: reference.project.companyName,
                    endDate: reference.project.endDate,
                    image: {
                        src: reference.project.imageUrl
                    },
                    primaryPhoto: mockProjectReferencePhoto,
                    description: null,
                    commercialProjectName: '',
                    kvwNumber: reference.project.kvwNumber,
                }))
                .sort((a, b) => a.createdAt < b.createdAt ? -1 : 1)
            )
        );
    }

    detail(id: number): Observable<ProjectReferenceDetailResponse> {
        const ref = mockProjectReferences.find(reference => reference.id === id);
        if (!ref) {
            return throwError('404 - not found');
        }
        const project = ref.project;

        if (id === 1) {
            return of({
                id,
                name: project.name,
                companyName: project.companyName,
                imageUrl: '/assets/images/jumbotron.jpg',
                primaryPhoto:  {...mockProjectReferencePhoto, srcset: {'416w': mockProjectReferencePhoto.originalUrl || ''}},
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vitae ex sed eros mattis tincidunt id vel augue.',
                properties: {
                    operationalStatus: 'Opgeleverd',
                    start: new Date('2021-01-01'),
                    end: new Date('2021-12-30'),
                    code: project.code
                },
                city: project.city,
                street: 'Korte Hengelosestraat',
                houseNumber: '1',
                postCode: '7511 JA',
                longitude: 6.8918588,
                latitude: 52.221202,
                status: ref.status,
                photos: [],
                companyLogo: null,
                commercialProjectName: '',
                kvwNumber: project.kvwNumber,
            });
        } else if (id === 2) {
            return of({
                id,
                name: project.name,
                companyName: project.companyName,
                imageUrl: '/assets/images/jumbotron.jpg',
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vitae ex sed eros mattis tincidunt id vel augue.',
                properties: {
                    phase: 'Afgebroken',
                    start: new Date('2022-01-01'),
                    end: new Date('2022-12-30'),
                    code: project.code
                },
                city: project.city,
                street: 'Stationsstraat',
                houseNumber: '11',
                postCode: '7607 GX',
                longitude: 6.654504,
                latitude: 52.3583532,
                status: ref.status,
                photos: [],
                primaryPhoto: null,
                companyLogo: null,
                commercialProjectName: '',
                kvwNumber: project.kvwNumber,
            });
        } else if (id === 3) {
            return of({
                id,
                name: project.name,
                companyName: project.companyName,
                imageUrl: '/assets/images/jumbotron.jpg',
                primaryPhoto:  {...mockProjectReferencePhoto, srcset: {'416w': mockProjectReferencePhoto.originalUrl || ''}},
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer vitae ex sed eros mattis tincidunt id vel augue.',
                properties: {
                    operationalStatus: 'Opgeleverd',
                    start: new Date('2021-01-01'),
                    end: new Date('2021-12-30'),
                    code: project.code
                },
                city: project.city,
                street: 'Korte Hengelosestraat',
                houseNumber: '1',
                postCode: '7511 JA',
                longitude: 6.8918588,
                latitude: 52.221202,
                status: ref.status,
                photos: [],
                companyLogo: null,
                commercialProjectName: 'BVGO Project commerciele naam',
                kvwNumber: project.kvwNumber,
            });
        }

        return throwError('404 - not found');
    }

    getFacets(search: string): Observable<SearchFacetGroupCollection[]> {
        return of([]);
    }


}
